<mat-chip-list class="filter_chip_list" #sortChipList>
    <div *ngFor="let sort of selectedSorts">
        <sort-direction-select
            class="flex"
            [sort]="sort"
            [allowDisableRemove]="
                selectedSorts.length == 1 && allowDisableRemove
            "></sort-direction-select>
    </div>
</mat-chip-list>
